import { ErrorMessages } from "../generated/errors";
/**
 * Map of error codes to human-readable error messages
 */
export const errorMap = ErrorMessages;
export const errorTransformer = async (ogError) => {
    const [errCode] = /ERR:[^" ]+/.exec(ogError.message) ?? [];
    if (errCode) {
        const humanMessage = errorMap[errCode] ?? "Unknown error";
        const message = `${errCode.replace("ERR:", "Error ")}: ${humanMessage}`;
        ogError.stack = `${message}\n    ${ogError.message}\n${ogError.stack}`;
        ogError.message = message;
        ogError.code = errCode;
        ogError.description = humanMessage;
        return ogError;
    }
    return ogError;
};
export async function wrapErrorsInternal(promiseOrGenerator) {
    try {
        if (typeof promiseOrGenerator === "function") {
            return await promiseOrGenerator();
        }
        else {
            return await promiseOrGenerator;
        }
    }
    catch (e) {
        throw await errorTransformer(e);
    }
}
/**
 * Decorator that wraps the return value of an async method with error transformation.
 */
export function wrapErrors() {
    return function (_target, _propertyKey, descriptor) {
        const originalMethod = descriptor.value;
        descriptor.value = async function (...args) {
            return wrapErrorsInternal(() => originalMethod.apply(this, args));
        };
        return descriptor;
    };
}
